import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';

export const CMS_CONFIG_OPEN_SEARCH = 'open-search';

export interface ICmsConfigOpenSearchDataContent {
    enableOpenSearch?: string[];
}

ICmsContentService.registerConfig({
    id: CMS_CONFIG_OPEN_SEARCH,
    name: 'Open Search Configuration',
    fields: [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-open-search',
            title: 'Open Search'
        },
        <NICmsContentField.IField>{
            key: 'enableOpenSearch',
            type: NICmsContentField.EFieldType.choice,
            title: 'Enable Open Search',
            options: [
                { key: 'homepage', title: 'Homepage' },
                { key: 'cms-page', title: 'CMS Page' },
                { key: 'product', title: 'Product Page' },
                { key: 'category', title: 'Category Page' },
                { key: 'blog-post', title: 'Blog Post' }
            ],
            multiple: true,
            default: []
        }
    ]
});